import React from 'react';
import type { ReviewKind } from './types';
import { KIND_META } from './constants';

interface Props {
  kind: ReviewKind;
  count: number;
}

export default function VelaBanner({ kind, count }: Props): React.ReactElement {
  const meta = KIND_META[kind];
  return (
    <div className="inline-flex items-start gap-3 bg-vela-fade border border-vela-wash rounded-lg px-4 py-3 mt-4 max-w-[720px]">
      <span className="w-7 h-7 rounded-full bg-gradient-to-br from-vela to-vela-deep text-white font-extrabold text-small inline-flex items-center justify-center flex-shrink-0">
        V
      </span>
      <div className="text-small text-ink2 leading-[1.5]">
        {meta.bannerBody(count)}
      </div>
    </div>
  );
}